import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform, Modal, Alert, } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { colores, fuentes } from '../../styles/variablesCss';
import { BACKEND_URL } from '../../Config/Const';
import CuponDescuento from './CuponDescuento';
import ModaleFleteGratis from './ModaleFleteGratis';
import TarjetaCreditoDebito from './FormasDePago/pagarTarjetaCreditoDebito';
import PagoBilleteraStaFe from './FormasDePago/PagoBilleteraStaFe';
import PagoModo from './FormasDePago/PagoModo';
import EncuestaFinalizar from './EncuestaFinalizar';
import UnificarEnvio from './UnificarEnvio';
import CargarDatos from './CargarDatos';
import Bono from './Bono';
import { useCheckoutContext } from '../../context/CheckoutContext';
import { useUser } from '../../context/UserContext';
import { useCart } from '../../context/CartContext';
import LoadingScreen from '../Common/LoadingScreen';
import { savePendingPurchase, trackPurchase, clearPendingPurchase } from '../../utils/analytics';
import { formatPrecio } from '../../utils/formatPrice';

// Función para cargar el SDK de MODO en la página web (evita duplicados)
const loadModoSDK = () => {
  if (typeof document === 'undefined') return;
  
  // Detectar si estamos en localhost (test) o en producción
  const isLocalhost = typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  
  const scriptSrc = isLocalhost
    ? 'https://ecommerce-modal.preprod.modo.com.ar/bundle.js'  // Test/Preprod
    : 'https://ecommerce-modal.modo.com.ar/bundle.js';          // Producción

  const existing = document.querySelector(
    'script[src*="ecommerce-modal.preprod.modo.com.ar/bundle.js"], script[src*="ecommerce-modal.modo.com.ar/bundle.js"]'
  );
  if (existing) return;
  const script = document.createElement('script');
  script.src = scriptSrc;
  script.async = true;
  document.body.appendChild(script);
};

const ResumenPedido = ({
  // Datos de la sucursal
  sucursalId,
  sucursalDireccion,
  sucursalTelefono,

  // Datos de cupones y descuentos
  cupon,
  setCupon,
  cargando,
  setDescuentoAplicado,
  descuentoAplicado,

  // Controles de estado
  showFormaPago,
  setShowFormaPago,
  modalFleteVisible,
  setModalFleteVisible,

  // Datos de bono
  bono,

  onEffectiveTotalChange,
}) => {
  // Obtener productos y totales del contexto del carrito
  const { totales, calcularTotal, productos } = useCart();
  // Estados para la gestión de pagos
  const [codigoPostal, setCodigoPostal] = useState('2300'); // Valor por defecto
  const [totalData, setTotalData] = useState(null);
  const [pagoData, setPagoData] = useState(null);

  // Estados para los distintos modales de pago
  const [showPagoTarjeta, setShowPagoTarjeta] = useState(false);
  const [showBilleteraQR, setShowBilleteraQR] = useState(false);
  const [showPagoModo, setShowPagoModo] = useState(false);
  const [showEncuesta, setShowEncuesta] = useState(false);
  const [showUnificarEnvio, setShowUnificarEnvio] = useState(false);
  const [showLoadingPago, setShowLoadingPago] = useState(false);
  // Totales provenientes de la API de cupón cuando resultado === true
  const [cuponTotals, setCuponTotals] = useState(null);
  // Modal para completar datos de usuario
  const [showCargarDatos, setShowCargarDatos] = useState(false);
  // Modal para mostrar bonos
  const [showModalBono, setShowModalBono] = useState(false);
  // Estado para controlar si el usuario acepta usar el bono (50% de descuento)
  const [usarBono, setUsarBono] = useState(false);
  // Estado para almacenar el saldo del bono
  const [saldoBono, setSaldoBono] = useState(0);

  const navigation = useNavigation();
  const { tarjeta, cuotas, coeficiente, totalDeCuota, totalFinal, setTotalFinal, setTotalDeCuota, saldoCuenta, tipoPago,
    tipoEntrega, codDic, precioFleteDireccion, deseaFactura, tipoResponsable, razonSocial, cuit, nombreAutorizado,
    dniAutorizado, observaciones, aceptaReemplazo, fechaRetiroSeleccionada,
    codigoHorarioSeleccionado, horarioTexto, nroEmision, nroPlan, marcaTarjeta, setDatosBilletera, setDatosModo,
    codCompraUnifica, setCodCompraUnifica, enviosPendientes, setEnviosPendientes, setTarjeta, setCuotas, setCoeficiente, setPlan,
    setNroEmision, setNroPlan, setMarcaTarjeta, telefonoFacturacion } = useCheckoutContext();
  const { mail, cel, codUsu } = useUser();
  const [checkingPendingShipments, setCheckingPendingShipments] = useState(false);
  // Calcular totales (si hay cuponTotals, priorizarlos)
  const subtotal = cuponTotals?.subtotal ?? (totales.subtotal || calcularTotal());
  const descuentoTotal = cuponTotals?.descuentos ?? (totales.descuentos || 0);
  const descuentoCuponAPI = cuponTotals?.descuentoCupon ?? 0;
  const percepcionesCart = totales.percepciones || 0;

  console.log(codDic)
  // Calcular el flete base primero (antes de aplicar descuentos)
  const fleteApi = (cuponTotals && typeof cuponTotals.precioEnvio === 'number') ? Number(cuponTotals.precioEnvio) : null;
  let fleteBase = 0;
  const calcularFleteLocal = () => {
    // Calcular con subtotal sin descuentos para determinar si hay flete gratis
    if (subtotal > 100000) return 0;
    const fleteCarrito = totales.precioFlete || 0;
    const fleteDireccion = precioFleteDireccion || 0;
    return parseInt(tipoEntrega) === 2
      ? Math.max(fleteCarrito, fleteDireccion)
      : fleteCarrito;
  };
  if (fleteApi !== null && fleteApi > 0) {
    fleteBase = fleteApi;
  } else {
    fleteBase = calcularFleteLocal();
  }

  // Calcular descuento por bono
  // Lógica: El bono cubre 50% de productos + 50% de flete si el saldo alcanza
  const mitadSubtotal = subtotal * 0.5;
  const mitadFlete = fleteBase * 0.5;
  const mitadTotal = mitadSubtotal + mitadFlete; // 50% del total (productos + flete)
  
  let descuentoBono = 0;
  let descuentoFleteConBono = 0;
  
  if (usarBono) {
    if (saldoBono >= mitadTotal) {
      // El saldo cubre el 50% completo (productos + flete)
      descuentoBono = mitadSubtotal;
      descuentoFleteConBono = mitadFlete;
    } else if (saldoBono >= mitadSubtotal) {
      // El saldo cubre el 50% de productos y parte del flete
      descuentoBono = mitadSubtotal;
      descuentoFleteConBono = saldoBono - mitadSubtotal; // Lo que queda se aplica al flete
    } else {
      // El saldo solo cubre parte de los productos
      descuentoBono = saldoBono;
      descuentoFleteConBono = 0;
    }
  }

  // Calcular el total de productos (sin flete)
  // Agregar percepciones solo si el usuario desea factura A o B
  const percepciones = deseaFactura ? (cuponTotals ? (cuponTotals.percepciones || 0) : percepcionesCart) : 0;
  const totalProductos = cuponTotals
    ? (subtotal - (descuentoTotal || 0) - (descuentoCuponAPI || 0) - descuentoBono + percepciones)
    : (subtotal - descuentoTotal - (descuentoAplicado || 0) - descuentoBono + percepciones);

  // Aplicar descuento al flete
  const fleteAMostrar = fleteBase - descuentoFleteConBono;

  // Total final incluyendo el flete: siempre recomponer con el flete vigente
  const total = (totalProductos + fleteAMostrar);

  // Notificar al padre el total efectivo cuando cambie
  React.useEffect(() => {
    if (typeof onEffectiveTotalChange === 'function') {
      onEffectiveTotalChange(total);
    }
  }, [total, onEffectiveTotalChange]);

  // Función para verificar envíos pendientes antes de mostrar el modal
  const verificarYMostrarUnificarEnvio = async () => {
    try {
      setCheckingPendingShipments(true);

      let userMail = mail;
      let userCodUsu = codUsu;

      // Obtener datos de autenticación
      if (Platform.OS === 'web') {
        userMail = localStorage.getItem('mail');
        userCodUsu = localStorage.getItem('codUsu');
      }

      const url = `${BACKEND_URL}/rest/fin/enviosPendientes?mail=${userMail}&codUsu=${userCodUsu}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();
      // Extraer envíos pendientes del dsResultado
      let envios = [];

      if (data?.dsResultado?.enviosPendientes) {
        envios = data.dsResultado.enviosPendientes;
      } else if (data?.response?.dsResultado?.dsResultado?.enviosPendientes) {
        envios = data.response.dsResultado.dsResultado.enviosPendientes;
      } else if (Array.isArray(data?.enviosPendientes)) {
        envios = data.enviosPendientes;
      }

      // Guardar los envíos pendientes en contexto
      setEnviosPendientes(envios);

      // Solo mostrar el modal si hay envíos pendientes
      if (envios.length > 0) {
        setShowUnificarEnvio(true);
      } else {
        // Si no hay envíos pendientes, avanzar directo a forma de pago
        setShowFormaPago(true);
      }
    } catch (err) {
      console.error('Error al verificar envíos pendientes:', err);
      // En caso de error, continuar con el flujo normal
      setShowFormaPago(true);
    } finally {
      setCheckingPendingShipments(false);
    }
  };

  // Resetear valores de tarjeta cuando cambia el tipo de pago
  React.useEffect(() => {
    // Limpiar todos los datos de tarjeta cuando cambia la forma de pago
    setTarjeta('');
    setCuotas('');
    setCoeficiente('');
    setPlan('');
    setNroEmision('');
    setNroPlan('');
    setMarcaTarjeta('');
    setTotalFinal(null);
    setTotalDeCuota(null);
  }, [tipoPago, setTarjeta, setCuotas, setCoeficiente, setPlan, setNroEmision, setNroPlan, setMarcaTarjeta, setTotalFinal, setTotalDeCuota]);

  // Recalcular totalFinal cuando cambia el tipo de entrega, flete o forma de pago
  React.useEffect(() => {
    // Si hay tarjeta y cuotas seleccionadas (financiación activa)
    if (tarjeta && cuotas && coeficiente && (tipoPago === '1' || tipoPago === '2')) {
      const precioFinal = (total * coeficiente).toFixed(2);
      const valorCuota = (precioFinal / cuotas).toFixed(2);

      setTotalFinal(precioFinal);
      setTotalDeCuota(valorCuota);
    } else {
      // Si no hay financiación (cambió de forma de pago), resetear al total sin coeficiente
      setTotalFinal(null);
      setTotalDeCuota(null);
    }
  }, [tipoEntrega, fleteAMostrar, total, tarjeta, cuotas, coeficiente, tipoPago, deseaFactura, percepciones, setTotalFinal, setTotalDeCuota]);

  // Cargar el código postal del localStorage al montar el componente
  React.useEffect(() => {
    const cargarCodigoPostal = () => {
      if (Platform.OS === 'web') {
        const cpGuardado = localStorage.getItem('codigoPostal');
        if (cpGuardado) {
          setCodigoPostal(cpGuardado);
        }
      }
      // Para React Native se podría implementar con AsyncStorage
    };
    cargarCodigoPostal();
  }, []);

  // Función para preparar los datos del pago
  const prepararDatosPago = () => {
    const tipoPagoNum = Number.parseInt(tipoPago, 10) || 0;
    const cuotasNum = Number.parseInt(cuotas, 10) || 1;
    const nroEmisorNum = Number.parseInt(nroEmision, 10);
    const nroPlanNum = Number.parseInt(nroPlan, 10);

    return {
      deseaFactura: deseaFactura,
      bono: usarBono, // true si el usuario aceptó usar el bono, false si no
      entrega: parseInt(tipoEntrega),
      coddic: tipoEntrega != 1 ? parseInt(codDic) : 0,
      tipoPago: tipoPagoNum,
      cuotas: cuotasNum,
      marcaTarjeta: marcaTarjeta,
      codPostalEntrega: parseInt(codigoPostal),
      fencdc: fechaRetiroSeleccionada,
      codHorario: parseInt(codigoHorarioSeleccionado),
      nombreAutorizado: nombreAutorizado,
      docAutoriza: dniAutorizado ? parseInt(dniAutorizado) : 0, 
      observaciones: observaciones,
      cel: cel,
      teo: telefonoFacturacion,
      aceptaReemplazo: aceptaReemplazo,
      codPromo: (cupon && cupon.trim()) || '',
      cuit: parseInt(cuit),
      rzo: razonSocial,
      tipoResponsable: parseInt(tipoResponsable),
      codCompraUnificar: parseInt(codCompraUnifica) || 0,
      nroEmisor: (tipoPagoNum === 1 && Number.isFinite(nroEmisorNum)) ? nroEmisorNum : 0,
      nroPlan: (tipoPagoNum === 1 && Number.isFinite(nroPlanNum)) ? nroPlanNum : 0
    };
  };

  const buildPendingPurchasePayload = () => ({
    value: Number(totalFinal || total || totalData?.total || 0),
    currency: 'ARS',
    content_ids: Array.isArray(productos) ? productos.map((producto) => String(producto.plu)).filter(Boolean) : [],
    contents: Array.isArray(productos)
      ? productos.map((producto) => ({
          id: String(producto.plu || ''),
          quantity: Number(producto.cantCarrito || producto.cant || 1),
          item_price: Number(producto.precio || producto.preUni || 0),
        }))
      : [],
    num_items: Array.isArray(productos)
      ? productos.reduce((acc, producto) => acc + Number(producto.cantCarrito || producto.cant || 1), 0)
      : 0,
    payment_method:
      tipoPago === '1' || tipoPago === '2'
        ? 'tarjeta'
        : tipoPago === '3'
          ? 'cuenta_empleado'
          : tipoPago === '4'
            ? 'billetera_santa_fe'
            : tipoPago === '5'
              ? 'modo'
              : '',
    event_id: `${Date.now()}_${tipoPago || 'sin_tipo'}`,
  });

  // Función para realizar el pago
  const realizarPago = async () => {
    let pagoExitoso = false;
    try {
      // Validar que se haya seleccionado fecha y horario si es retiro
      if (tipoEntrega === 1) {
        if (!fechaRetiroSeleccionada || fechaRetiroSeleccionada === '' || fechaRetiroSeleccionada === '0') {
          Alert.alert('Error', 'Debes seleccionar una fecha de retiro antes de continuar', [{ text: 'Aceptar' }]);
          return;
        }
        if (!codigoHorarioSeleccionado || codigoHorarioSeleccionado === '' || codigoHorarioSeleccionado === '0' || codigoHorarioSeleccionado === 0) {
          Alert.alert('Error', 'Debes seleccionar un horario de retiro antes de continuar', [{ text: 'Aceptar' }]);
          return;
        }
      }

      // Limpiar la bandera de unificación ya que el usuario está procediendo con el pago
      if (Platform.OS === 'web' && typeof sessionStorage !== 'undefined') {
        sessionStorage.removeItem('unificoAceptado');
      }

      // Mostrar overlay de carga mientras preparamos el pago
      setShowLoadingPago(true);
      // Resetear estado de intentos previos para forzar remount limpio
      setShowBilleteraQR(false);
      setShowPagoModo(false);
      setPagoData(null);
      setTotalData(null);
      setDatosBilletera(null);
      setDatosModo(null);

      let userMail = mail;
      let userCodUsu = codUsu;
      let suc = null;
      // Obtener datos de autenticación
      if (Platform.OS === 'web') {
        userMail = localStorage.getItem('mail') || 'agustinhischier@cormoran.com.ar';
        userCodUsu = localStorage.getItem('codUsu') || 'cObaHihcaEcdbdkl';
        suc = localStorage.getItem('sucursalId');
      }

      // Si es pago con MODO, cargar el SDK correcto según el entorno
      if (tipoPago === '5') {
        loadModoSDK();
      }

      // Detectar entorno MODO (producción o test) basado en hostname
      const isLocalhost = (typeof window !== 'undefined' && 
        (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'));

      // Construir URL con parámetros (incluir entorno MODO si es pago con MODO)
      let url = `${BACKEND_URL}/rest/fin/pago?mail=${userMail}&codUsu=${userCodUsu}&suc=${suc}`;
      
      // Preparar datos para el cuerpo de la solicitud
      const datosPago = prepararDatosPago();
      savePendingPurchase(buildPendingPurchasePayload());

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ datos: datosPago })
      });

      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const responseData = await response.json();

      // Extraer y guardar los datos de total y pago
      if (responseData?.response?.dsResultado?.dsResultado) {
        const dsResultado = responseData.response.dsResultado.dsResultado;

        // Guardar datos de total
        if (Array.isArray(dsResultado.total) && dsResultado.total.length > 0) {
          setTotalData(dsResultado.total[0]);
        }

        // Guardar datos de pago
        if (Array.isArray(dsResultado.pago) && dsResultado.pago.length > 0) {
          setPagoData(dsResultado.pago[0]);
        }
      }

      // Verificar si la respuesta es exitosa
      if (responseData?.response?.dsResultado?.dsResultado?.resultado &&
        Array.isArray(responseData.response.dsResultado.dsResultado.resultado) &&
        responseData.response.dsResultado.dsResultado.resultado.length > 0 &&
        responseData.response.dsResultado.dsResultado.resultado[0].resultado === true) {

        pagoExitoso = true;

        // Extraer datos de billetera cuando tipoPago es 4
        if (tipoPago === '4' && responseData.response.dsResultado.dsResultado.billetera &&
          Array.isArray(responseData.response.dsResultado.dsResultado.billetera) &&
          responseData.response.dsResultado.dsResultado.billetera.length > 0) {

          const billeteraData = responseData.response.dsResultado.dsResultado.billetera[0];

          // Guardar los datos de billetera en el contexto
          setDatosBilletera({
            qrCaja: billeteraData.qrCaja,
            ordenId: billeteraData.ordenId,
            oid: billeteraData.oid,
            cajaId: billeteraData.cajaId
          });
        }

        // Extraer datos de MODO cuando tipoPago es 5
        if (tipoPago === '5' && responseData.response.dsResultado.dsResultado.modo &&
          Array.isArray(responseData.response.dsResultado.dsResultado.modo) &&
          responseData.response.dsResultado.dsResultado.modo.length > 0) {

          const modoData = responseData.response.dsResultado.dsResultado.modo[0];

          // Guardar los datos de MODO en el contexto
          setDatosModo({
            qr: modoData.qr,
            id: modoData.id,
            deepLink: modoData.deepLink
          });
        }

        if (!(tipoPago === '1' || tipoPago === '2' || tipoPago === '4' || tipoPago === '5')) {
          trackPurchase();
        }

      } else {
        clearPendingPurchase();
        // Si hay un mensaje de error en la respuesta, mostrarlo
        const mensajeError = responseData?.response?.dsResultado?.dsResultado?.resultado?.[0]?.mensaje || 'Error al procesar el pago';
        Alert.alert('Error', mensajeError, [{ text: 'Aceptar' }]);
      }
    } catch (err) {
      clearPendingPurchase();
      Alert.alert('Error', `Error al procesar el pago: ${err.message}`, [{ text: 'Aceptar' }]);
    } finally {

      if (!pagoExitoso) {
        setShowLoadingPago(false);
        return;
      }

      // Determinar qué modal mostrar según el tipo de pago
      if (tipoPago === '4') {
        setShowBilleteraQR(true); // Mostrar QR de Billetera Santa Fe
        setShowLoadingPago(false);
      } else if (tipoPago === '5') {
        setShowPagoModo(true); // Mostrar QR de MODO
        setShowLoadingPago(false);
      } else if (tipoPago === '1' || tipoPago === '2') {
        setShowPagoTarjeta(true); // Mostrar modal de tarjeta
      } else {
        // Para otros métodos de pago, mostrar directamente la encuesta
        setShowLoadingPago(false);
        setShowEncuesta(true);
      }
    }
  };

  // Manejar el cierre del modal de pago con tarjeta
  const handleTarjetaClose = () => {
    setShowPagoTarjeta(false);
    // No mostrar encuesta aquí - solo se muestra cuando el pago es exitoso en PagoOK
  };

  // Manejar el cierre del QR de MODO
  const handlePagoModoClose = () => {
    // Cerrar exclusivamente el modal de MODO para devolver el control de la página
    setShowPagoModo(false);
    // La encuesta se abrirá en el flujo correspondiente (aprobado), no automáticamente aquí
  };

  // Manejar el cierre de la encuesta
  const handleEncuestaClose = () => {
    setShowEncuesta(false);
    navigation.navigate('Home');
  };

  const handleEncuestaSubmit = (datosEncuesta) => {
    try {
    } catch (e) {
    }
    handleEncuestaClose();
  };

  // Manejar la confirmación de unificar envío
  const handleUnificarConfirm = (envioSeleccionado) => {
    setShowUnificarEnvio(false);
    // Guardar el código de compra para usarlo en el pago
    if (envioSeleccionado && envioSeleccionado.codCompra) {
      // Guardar en el contexto
      setCodCompraUnifica(envioSeleccionado.codCompra);
      // Marcar que el usuario aceptó unificar
      if (Platform.OS === 'web' && typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem('unificoAceptado', 'true');
      }
    } else {
      // Resetear a 0 si no hay envío seleccionado
      setCodCompraUnifica(0);

    }
    // Continuar con el flujo normal
    setShowFormaPago(true);
  };

  // Manejar el rechazo de unificar envío
  const handleUnificarReject = () => {
    setShowUnificarEnvio(false);
    // Continuar sin unificar - resetear a 0
    setCodCompraUnifica(0);
    // Limpiar la bandera de unificación
    if (Platform.OS === 'web' && typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem('unificoAceptado');
    }
    setShowFormaPago(true);
  };


  return (
    <View style={styles.seccionDerecha}>
      <View style={styles.seccionSuperiorFija}>
        <Text style={styles.seccionTitulo}>¿Todo en orden? Revisá tu pedido</Text>

        {/* Cartelito con la información de la sucursal */}
        {sucursalId && (
          <View style={styles.sucursalContainer}>
            <Text style={styles.sucursalTitulo}>
              {`Pingüino ${sucursalId}`}
            </Text>
            <Text style={styles.sucursalDireccion}>{sucursalDireccion}</Text>
            <Text style={styles.sucursalTelefono}>Tel: {sucursalTelefono}</Text>
          </View>
        )}

        {/* Cupón de descuento - solo visible después de CONTINUAR */}
        {showFormaPago && (
          <View>
            <CuponDescuento
              cupon={cupon}
              setCupon={setCupon}
              cargando={cargando}
              setDescuentoAplicado={setDescuentoAplicado}
              onCuponTotals={setCuponTotals}
            />
          </View>
        )}

        {/* Resumen de totales */}
        <Text style={styles.tituloSeccion}>RESUMEN DE PEDIDO</Text>

        {/* Resumen de entrega/envío */}
        {showFormaPago && <View style={styles.resumenEntregaContainer}>
          {tipoEntrega && <View style={styles.lineaTotales}>
            <Text style={styles.textoTotales}>Tipo</Text>
            <Text style={styles.valorTotales}>
              {parseInt(tipoEntrega) === 1 ? 'Retiro en sucursal' : 'Envío a domicilio'}
            </Text>
          </View>}

          <View style={styles.lineaTotales}>
            <Text style={styles.textoTotales}>
              Flete{descuentoFleteConBono > 0 ? ' (50% desc.)' : ''}
            </Text>
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
              {descuentoFleteConBono > 0 && (
                <Text style={[styles.valorTotales, { textDecorationLine: 'line-through', color: colores.grisOscuro, fontSize: 12 }]}>
                  ${formatPrecio(fleteBase, true)}
                </Text>
              )}
              <Text style={styles.valorTotales}>
                {fleteAMostrar > 0 ? `$${formatPrecio(fleteAMostrar, true)}` : '$0'}
              </Text>
            </View>
          </View>
          {fechaRetiroSeleccionada && <View style={styles.lineaTotales}>
            <Text style={styles.textoTotales}>Día</Text>
            <Text style={styles.valorTotales}>{fechaRetiroSeleccionada || 'A confirmar'}</Text>
          </View>}
          {horarioTexto && <View style={styles.lineaTotales}>
            <Text style={styles.textoTotales}>Horario</Text>
            <Text style={styles.valorTotales}>{horarioTexto || 'A confirmar'}</Text>
          </View>}
        </View>}
        <View style={styles.totalesContainer}>
          <View style={styles.lineaTotales}>
            <Text style={styles.textoTotales}>Subtotal productos</Text>
            <Text style={styles.valorTotales}>{`$ ${formatPrecio(subtotal || 0, true)}`}</Text>
          </View>
          {!usarBono && (
            <View style={styles.lineaTotales}>
              <Text style={styles.textoTotales}>Descuentos</Text>
              <Text style={styles.valorDescuento}>
                {descuentoTotal > 0 ? `-$ ${formatPrecio(descuentoTotal, true)}` : `$ ${formatPrecio(0, true)}`}
              </Text>
            </View>
          )}
          {descuentoAplicado > 0 && (
            <View style={styles.lineaTotales}>
              <Text style={[styles.textoTotales, { fontSize: 12 }]}>• Cupón</Text>
              <Text style={[styles.valorDescuento, { fontSize: 12 }]}>-${formatPrecio(descuentoAplicado, true)}</Text>
            </View>
          )}
          {usarBono && descuentoBono > 0 && (
            <View style={styles.lineaTotales}>
              <Text style={[styles.textoTotales, { fontSize: 12 }]}>• Bono (50% desc.)</Text>
              <Text style={[styles.valorDescuento, { fontSize: 12 }]}>-${formatPrecio(descuentoBono, true)}</Text>
            </View>
          )}
          {deseaFactura && percepciones > 0 && (
            <View style={styles.lineaTotales}>
              <Text style={styles.textoTotales}>Percepciones</Text>
              <Text style={styles.valorTotales}>${formatPrecio(percepciones, true)}</Text>
            </View>
          )}

          {/* Resumen de financiación/pago según método */}
          {(
            // Si es tarjeta (1 o 2) y hay datos, mostrar financiación
            (tipoPago === '1' || tipoPago === '2') && tarjeta && cuotas
          ) ? (
            <View>
              <View style={styles.separadorFinanciacion}>
                <Text style={styles.tituloFinanciacion}>Resumen de financiación</Text>
              </View>
              <View style={styles.lineaTotales}>
                <Text style={styles.textoTotales}>Tarjeta</Text>
                <Text style={styles.valorTotales}>{tarjeta}</Text>
              </View>
              <View style={styles.lineaTotales}>
                <Text style={styles.textoTotales}>Cuotas</Text>
                <Text style={styles.valorTotales}>{cuotas}</Text>
              </View>
              <View style={styles.lineaTotales}>
                <Text style={styles.textoTotales}>Valor de cuota</Text>
                <Text style={styles.valorTotales}>{`$ ${formatPrecio(totalDeCuota || 0, true)}`}</Text>
              </View>
            </View>
          ) : (
            <View>
              <View style={styles.separadorFinanciacion}>
                <Text style={styles.tituloFinanciacion}>Resumen de pago</Text>
              </View>
              <View style={styles.lineaTotales}>
                <Text style={styles.textoTotales}>Modo de pago</Text>
                <Text style={styles.valorTotales}>
                  {(() => {
                    switch (String(tipoPago)) {
                      case '1': return 'Tarjeta de crédito';
                      case '2': return 'Tarjeta de débito';
                      case '3': return 'Cuenta de empleado';
                      case '4': return 'Billetera Santa Fe';
                      case '5': return 'MODO App';
                      default: return 'Otro';
                    }
                  })()}
                </Text>
              </View>
            </View>
          )}
          <View style={styles.lineaTotales}>
            <Text style={styles.textoTotal}>Total a pagar</Text>
            <Text style={styles.valorTotal}>{`$ ${formatPrecio(totalFinal ? parseFloat(totalFinal) : total, true)}`}</Text>
          </View>
        </View>

        {/* Botones de acción */}
        <TouchableOpacity
          style={[styles.botonContinuar, showFormaPago && !(
            // Si es tarjeta: necesitamos tarjeta y cuotas
            (tarjeta && cuotas) ||
            // Si es cuenta de empleado: necesitamos saldo suficiente
            (tipoPago === '3' && saldoCuenta && parseFloat(saldoCuenta.disponible) >= parseFloat(totalFinal || total)) ||
            // Si es Billetera Santa Fe o MODO app: siempre habilitado
            (tipoPago === '4' || tipoPago === '5')
          ) && styles.botonDeshabilitado]}
          disabled={checkingPendingShipments || (showFormaPago && !(
            // Si es tarjeta: necesitamos tarjeta y cuotas
            (tarjeta && cuotas) ||
            // Si es cuenta de empleado: necesitamos saldo suficiente
            (tipoPago === '3' && saldoCuenta && parseFloat(saldoCuenta.disponible) >= parseFloat(totalFinal || total)) ||
            // Si es Billetera Santa Fe o MODO app: siempre habilitado
            (tipoPago === '4' || tipoPago === '5')
          ))}
          className="purchase"
          onPress={async () => {
            // Scroll al top en pantallas pequeñas
            if (typeof window !== 'undefined') {
              const isMobile = window.innerWidth < 768;
              if (isMobile) {
                // Intentar múltiples métodos para hacer scroll al top
                try {
                  // Método 1: window.scrollTo
                  window.scrollTo(0, 0);

                  // Método 2: document.documentElement
                  document.documentElement.scrollTop = 0;

                  // Método 3: document.body
                  document.body.scrollTop = 0;

                  // Método 4: Buscar todos los elementos scrollables
                  const allElements = document.querySelectorAll('*');
                  allElements.forEach(el => {
                    if (el.scrollTop > 0) {
                    //  console.log('🔍 Elemento con scroll encontrado:', el.className || el.tagName, 'scrollTop:', el.scrollTop);
                      el.scrollTop = 0;
                    }
                  });

                 // console.log('✅ Scroll ejecutado');

                  // Verificar después del scroll
                  setTimeout(() => {
                    //console.log('🔄 Después del scroll - window.scrollY:', window.scrollY);
                  }, 100);
                } catch (error) {
                  //console.error('❌ Error al hacer scroll:', error);
                }
              }
            }

            // Validación de datos del usuario (requiere 'nombre' en localStorage)
            if (Platform.OS === 'web') {
              const nombreLS = localStorage.getItem('nombre');
              if (!nombreLS || !String(nombreLS).trim()) {
                setShowCargarDatos(true);
                return; // Detener flujo hasta que complete datos
              }
            }

            if (!showFormaPago) {
              // Verificar si hay saldo de bono antes de abrir el modal
             // console.log('🎟️ Verificando saldo de bono...');
              
              try {
                const userMail = Platform.OS === 'web' ? localStorage.getItem('mail') : mail;
                const userCodUsu = Platform.OS === 'web' ? localStorage.getItem('codUsu') : codUsu;
                
                const response = await fetch(`${BACKEND_URL}/rest/fin/bono?mail=${userMail}&codUsu=${userCodUsu}`, {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                });
                
                if (response.ok) {
                  const data = await response.json();
                  let saldoBonoAPI = 0;
                  
                  if (data.dsResultado && data.dsResultado.bonoEmpleado && data.dsResultado.bonoEmpleado.length > 0) {
                    saldoBonoAPI = data.dsResultado.bonoEmpleado[0].saldoBono || 0;
                  }
                  
                 // console.log('💰 Saldo de bono obtenido:', saldoBonoAPI);
                  
                  if (saldoBonoAPI > 0) {
                    // Solo abrir modal si hay saldo
                  //  console.log('✅ Hay saldo de bono, abriendo modal...');
                    setShowModalBono(true);
                    return; // Detener el flujo hasta que cierre el modal
                  } else {
                  //  console.log('❌ No hay saldo de bono, continuando sin modal...');
                    // No hay saldo, continuar con el flujo normal
                    await verificarYMostrarUnificarEnvio();
                  }
                } else {
                //  console.log('⚠️ Error al obtener saldo de bono, continuando sin modal...');
                  await verificarYMostrarUnificarEnvio();
                }
              } catch (error) {
              //  console.error('❌ Error al verificar saldo de bono:', error);
                await verificarYMostrarUnificarEnvio();
              }
              return;
            } else if (
              // Si es tarjeta con datos de financiación o cuenta empleado con saldo suficiente
              (tarjeta && cuotas) ||
              (tipoPago === '3' && saldoCuenta && parseFloat(saldoCuenta.disponible) >= parseFloat(totalFinal || total)) ||
              // Si es Billetera Santa Fe o MODO app
              (tipoPago === '4' || tipoPago === '5')
            ) {
              // Realizar el pago directamente desde este componente
              realizarPago();
            }
          }}
        >
          <Text style={styles.botonContinuarTexto}>
            {checkingPendingShipments ? 'VERIFICANDO...' : (!showFormaPago ? 'CONTINUAR' : 'IR A PAGAR')}
          </Text>
        </TouchableOpacity>


        <TouchableOpacity
          onPress={() => {
            if (Platform.OS === 'web') {
              window.location.href = '/productos?masCompras=true';
            } else {
              navigation.navigate('Productos');
            }
          }}
        >
          <Text style={styles.botonSeguirComprandoTexto}>Elegir más productos</Text>
        </TouchableOpacity>

        {/* Modal de flete gratis */}
        <ModaleFleteGratis
          visible={modalFleteVisible}
          onClose={() => setModalFleteVisible(false)}
          subtotal={subtotal}
          total={total}
        />

        {/* Modal de unificar envío */}
        <UnificarEnvio
          visible={showUnificarEnvio}
          onClose={() => setShowUnificarEnvio(false)}
          onConfirm={handleUnificarConfirm}
          onReject={handleUnificarReject}
        />

        {/* Modal para cargar datos de usuario cuando falta 'nombre' */}
        {showCargarDatos && (
          <Modal
            visible={showCargarDatos}
            transparent={true}
            animationType="fade"
            onRequestClose={() => setShowCargarDatos(false)}
          >
            <CargarDatos onClose={() => setShowCargarDatos(false)} />
          </Modal>
        )}
      </View>

      {/* Modal para procesar pago con tarjeta */}
      {showPagoTarjeta && (
        <Modal
          visible={showPagoTarjeta}
          transparent={true}
          animationType="slide"
          onRequestClose={handleTarjetaClose}
          style={{ flex: 1 }}
        >
          <View style={{ flex: 1 }}>
            <TarjetaCreditoDebito
              total={totalData ? totalData.total : 0}
              hash={pagoData?.hash || ''}
              urlConsulta={pagoData?.urlConsulta || ''}
              fechor={pagoData?.fechor || ''}
              storename={pagoData?.storename || ''}
              oid={pagoData?.oid || ''}
              marcaTarjeta={pagoData?.paymentMethod || ''}
              oidTarjeta={pagoData?.oid || ''}
              pagoTarjeta={pagoData?.cardFunction || 'Credit'}
              plan={cuotas}
              coddic={codDic}
              fencdc={fechaRetiroSeleccionada}
              aceptaReemplazo={aceptaReemplazo}
              nroEmisor={nroEmision}
              nroPlan={nroPlan}
              onReady={() => {
                setShowLoadingPago(false);
              }}
              onSuccess={() => {
                setShowPagoTarjeta(false);
                trackPurchase();
                setShowEncuesta(true);
              }}
              onCancel={() => {
                clearPendingPurchase();
                setShowLoadingPago(false);
                // No cerrar el modal automáticamente - dejar que el usuario vea PagoFail.js
                // handleTarjetaClose();
              }}
            />
          </View>
        </Modal>
      )}

      {/* Modal para Billetera Santa Fe QR */}
      {showBilleteraQR && (
        <PagoBilleteraStaFe
          total={totalData ? totalData.total : 0}
          qrData={pagoData && pagoData.billetera && pagoData.billetera[0] ? pagoData.billetera[0].qrCaja : null}
          onClose={(estadoPago) => {
            setShowBilleteraQR(false);
            // Reset de datos para forzar un nuevo llamado en el próximo intento
            setDatosBilletera(null);
            setPagoData(null);
            setTotalData(null);
            setShowLoadingPago(false);
            
            // Si el pago fue aprobado, mostrar la encuesta
            if (estadoPago === 'aprobada') {
              setShowEncuesta(true);
            } else {
              // Si fue rechazado o cancelado, limpiar la compra pendiente
              clearPendingPurchase();
            }
          }}
        />

      )}

      {/* MODO QR (el SDK ya maneja su propio modal) */}
      {showPagoModo && (
        <PagoModo
          cupon={cupon}
          total={totalData ? totalData.total : 0}
          prepararDatosPago={prepararDatosPago}
          onClose={() => {
            setShowLoadingPago(false);
            handlePagoModoClose();
          }}
        />
      )}

      {/* Modal de encuesta final */}
      <View>
        <EncuestaFinalizar
          visible={showEncuesta}
          onClose={handleEncuestaClose}
          onSubmit={handleEncuestaSubmit}
          onOpen={() => setShowLoadingPago(false)}
        />
      </View>

      {/* Overlay de carga al iniciar pago */}
      {showLoadingPago && (
        <LoadingScreen message="Cargando pago..." />
      )}

      {/* Modal de bonos */}
      <Bono
        visible={showModalBono}
        onClose={async (respuesta) => {
        //  console.log('🎟️ Respuesta del modal de bonos:', respuesta);
          setShowModalBono(false);
          
          // Si el usuario acepta usar el bono, activar el descuento y guardar el saldo
          if (respuesta.usarBono === true) {
          //  console.log('✅ Usuario acepta usar bono');
          //  console.log('💰 Saldo del bono:', respuesta.saldoBono);
            setUsarBono(true);
            setSaldoBono(respuesta.saldoBono);
          } else {
          //  console.log('❌ Usuario rechaza usar bono');
            setUsarBono(false);
            setSaldoBono(0);
          }
          
          // Continuar con el flujo normal (verificar envíos pendientes)
          await verificarYMostrarUnificarEnvio();
        }}
        bono={bono}
      />
    </View>
  );
};

// Estilos del componente
const styles = StyleSheet.create({
  seccionDerecha: {
    width: '100%',
  },
  seccionSuperiorFija: {
    backgroundColor: colores.blanco,
    padding: 15,
    borderRadius: 5,
    boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.1)',
    elevation: 3,
    marginBottom: 20,
    padding: 15,
    position: Platform.OS === 'web' ? 'sticky' : 'relative',
    top: Platform.OS === 'web' ? 0 : undefined,
  },
  seccionTitulo: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 15,
    textAlign: 'center',
    color: colores.textoPrincipal,
  },
  sucursalContainer: {
    backgroundColor: colores.grisClaro,
    borderRadius: 5,
    padding: 8,
    alignSelf: 'center',
    alignItems: 'center',
    width: '100%',
  },
  sucursalTitulo: {
    fontSize: 14,
    fontWeight: 'bold',
    color: colores.textoPrincipal,
    marginBottom: 5,
    textAlign: 'center',
  },
  sucursalDireccion: {
    fontSize: 12,
    color: colores.texto,
    marginBottom: 3,
    textAlign: 'center',
  },
  sucursalTelefono: {
    fontSize: 12,
    color: colores.texto,
    textAlign: 'center',
  },
  tituloSeccion: {
    fontWeight: 'bold',
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 8,
    marginTop: 8,
    color: colores.rojo,
  },
  lineaTotales: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  textoTotales: {
    color: colores.texto,
  },
  valorTotales: {
    color: colores.textoPrincipal,
    fontWeight: '500',
  },
  valorDescuento: {
    color: colores.exito,
    fontWeight: '500',
  },
  totalFinal: {
    marginTop: 10,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: colores.grisClaro,
  },
  textoTotal: {
    color: colores.textoPrincipal,
    fontWeight: 'bold',
    fontSize: 16,
  },
  valorTotal: {
    color: colores.rojo,
    fontWeight: 'bold',
    fontSize: 18,
  },
  resumenEntregaContainer: {
    marginTop: 5,
    marginBottom: 10,
    padding: 10,
    backgroundColor: colores.blanco,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: colores.grisClaro,
  },
  separadorFinanciacion: {
    borderTopWidth: 1,
    borderTopColor: colores.grisClaro,
    paddingTop: 10,
  },
  tituloFinanciacion: {
    fontSize: 14,
    fontWeight: 'bold',
    color: colores.textoPrincipal,
    marginBottom: 5,
  },
  botonContinuar: {
    backgroundColor: colores.rojo,
    paddingVertical: 15,
    borderRadius: 5,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 15,
  },
  botonDeshabilitado: {
    backgroundColor: colores.grisClaro,
    opacity: 0.7,
  },
  botonContinuarTexto: {
    color: colores.blanco,
    fontFamily: fuentes.bold,
    fontSize: 16,
    textTransform: 'uppercase',
  },
  botonSeguirComprandoTexto: {
    color: colores.rojo,
    textAlign: 'center',
    marginTop: 10,
    fontFamily: fuentes.medium,
    fontSize: 14,
  }
});

export default ResumenPedido;
